import { Trans } from '@lingui/react'

import { Container } from '@twisto/components/atoms/container'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigMoneyIcon } from '@twisto/icons'

import * as styles from './installments-min-due-amount-headline.styles'

export const InstallmentsMinDueAmountHeadline = () => (
  <section css={styles.root} data-testid="minimum-due-amount-headline">
    <Container noPadding size="tiny">
      <Headline>
        <HeadlineIcon>
          <BigMoneyIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.components.minimumDueAmount.headline.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans
            components={[<strong key="0" />]}
            id="flow.components.minimumDueAmount.headline.subtitle"
          />
        </HeadlineSubtitle>
      </Headline>
    </Container>
  </section>
)
